import { render, staticRenderFns } from "./regList.vue?vue&type=template&id=f6ba6570&scoped=true"
import script from "./regList.vue?vue&type=script&lang=js"
export * from "./regList.vue?vue&type=script&lang=js"
import style0 from "./regList.vue?vue&type=style&index=0&id=f6ba6570&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ba6570",
  null
  
)

export default component.exports